










import { BryntumGrid } from '@bryntum/schedulerpro-vue'
import { GroupGridConfig } from '@/components/bryntum/configs/GroupGridConfig'

export default {
  name: 'GroupGrid',

  components: {
    BryntumGrid,
  },

  props: {
    rawData: { type: Array, default: undefined },
    isAdmin: { type: Boolean, default: false },
  },

  emits: [
    'gridMounted',
    'gridUnmounted',
  ],

  data() {
    return {
      GroupGridConfig,
      gridInstance: null,
    }
  },

  computed: {
    createGroupUrl(): string {
      return `${process.env.VUE_APP_ADMIN_PORTAL_URL}/player-groups/create`
    },
  },

  watch: {
    isAdmin(value: boolean): void {
      this.updateGridRights(value)
    }
  },

  mounted(): void {
    this.gridInstance = this.$refs.groupGrid.instance

    this.updateGridRights(this.isAdmin)
    this.gridInstance.on('addNewGroupClick', this.onAddNewGroupClick)

    this.$emit('gridMounted', this.gridInstance)
  },

  beforeDestroy(): void {
    this.gridInstance.un('addNewGroupClick')

    this.$emit('gridUnmounted', this.gridInstance)
  },

  methods: {
    updateGridRights(isAdmin: boolean): void {
      this.gridInstance.adminRights = isAdmin
    },
    onAddNewGroupClick(): void {
      if (this.isAdmin) {
        window.open(this.createGroupUrl)
      }
    },
  }
}
